import { useInfiniteQuery } from "@tanstack/react-query";
import { getProductReviews } from "@/features/rating/api/get-product-reviews";
import type { ProductReviewsFilters } from "@/features/rating/types/product-rating.type";

const PAGE_LIMIT = 10;

export const useProductReviews = ({
  productId,
  filters,
  enabled,
}: {
  productId: string;
  filters: ProductReviewsFilters;
  enabled?: boolean;
}) => {
  return useInfiniteQuery({
    queryKey: ["product-reviews", productId, filters],
    queryFn: ({ pageParam }) =>
      getProductReviews(productId, pageParam, PAGE_LIMIT, filters),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { page, limit, total } = lastPage.pagination;
      const loaded = page * limit;
      return loaded < total ? page + 1 : undefined;
    },
    enabled,
    retry: false,
  });
};
